var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeFlowerFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #000;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.7,16c-3.7,0-7.5,1.2-10.6,3.7-3.2,2.6-5.1,6-6,9.5-.2,0-.5,0-.7,0-3.8,0-7.6,1.4-10.7,3.9-7.4,5.8-8.4,16.5-2.6,23.8,1.4,1.8,3.1,3.2,5.1,4.2-1.9,5.8-1,11.9,2.8,16.6,3.3,4.2,8.2,6.3,13.1,6.3s7.5-1.2,10.7-3.7c.2-.2.5-.3.7-.5,3.1,2.4,6.8,3.7,10.5,3.7s7.4-1.2,10.5-3.7c6.3-5.1,8.1-13.8,4.6-20.7.3-.3.9-.5,1.2-1,7.4-5.8,8.4-16.5,2.6-23.8-3.5-4.3-8.5-6.4-13.6-6.4s-1.1,0-1.7,0c-.5-1.9-1.6-3.9-3-5.4-3.2-4.3-8.1-6.5-13-6.5h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeFlowerFill);
export default __webpack_public_path__ + "static/media/acae_flower_fill.462c96a4.svg";
export { ForwardRef as ReactComponent };